import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import API from "../../api";

export default function PracticePlayTest() {

  const { id } = useParams();

  const [test, setTest] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [answers, setAnswers] = useState({});
  const [showResult, setShowResult] = useState(false);

  // FETCH TEST
  useEffect(() => {
    const fetchTest = async () => {
      try {
        const res = await API.get(`/test-types/practice/${id}`);

        const mapped = (res.data.questions || []).map(q => ({
          ...q,
          type: q.type?.toLowerCase() || "mcq"
        }));

        setTest({ ...res.data, questions: mapped });

      } catch (err) {
        console.error("Error fetching test:", err);
      }
    };

    fetchTest();
  }, [id]);

  if (!test) return <p className="text-center mt-10">Loading Practice...</p>;

  const q = test.questions[currentIndex] || {};
  const qId = q._id;

  /* ================= UNIVERSAL CORRECT INDEX ================= */

  let correctIndex = null;

  if (typeof q.answer === "object" && q.answer !== null) {
    correctIndex = q.answer.index;

  } else if (typeof q.answer === "number") {
    correctIndex = q.answer;

  } else if (typeof q.answer === "string") {

  const val = q.answer.trim().toUpperCase();

  // LETTER BASED (A,B,C,D,E)
  if (/^[A-Z]$/.test(val)) {
    correctIndex = val.charCodeAt(0) - 65;
  }

  // fallback: match by text
  else {
    const found = q.options?.findIndex(
      o => o.text?.toLowerCase() === val.toLowerCase()
    );

    if (found !== -1) correctIndex = found;
  }
}

  /* ========================================================== */

  const handleSelect = (index) => {
    setAnswers(prev => ({ ...prev, [qId]: index }));
    setShowResult(true);
  };

  const handleNext = () => {
    setShowResult(false);
    setCurrentIndex(prev => prev + 1);
  };

  return (
    <div className="min-h-screen bg-gray-50 flex">

      {/* SIDEBAR */}
      <aside className="w-64 bg-white shadow p-4">
        <h2 className="font-bold text-blue-700 mb-4 text-center">
          Practice Navigator
        </h2>

        <div className="grid grid-cols-4 gap-2">
          {test.questions.map((_, i) => (
            <button
              key={i}
              onClick={() => {
                setCurrentIndex(i);
                setShowResult(false);
              }}
              className={`h-8 rounded ${
                i === currentIndex
                  ? "bg-blue-600 text-white"
                  : "bg-gray-200"
              }`}
            >
              {i + 1}
            </button>
          ))}
        </div>
      </aside>

      {/* MAIN */}
      <main className="flex-1 p-6">

        <h1 className="text-xl font-bold mb-4">
          {test.title} – Practice Mode
        </h1>

        <div className="bg-white rounded-xl shadow p-6">

          <h2 className="mb-4 font-semibold">
            Q{currentIndex + 1}. {q.question}
          </h2>

          {/* QUESTION MEDIA */}
          {q.media?.url && (
            q.media.type === "video"
              ? (
                <video
                  src={`${process.env.REACT_APP_API_BASE_URL}${q.media.url}`}
                  controls
                  className="h-48 mb-4 rounded"
                />
              )
              : (
                <img
                  src={`${process.env.REACT_APP_API_BASE_URL}${q.media.url}`}
                  className="h-48 mb-4 rounded"
                  alt=""
                />
              )
          )}

          {/* OPTIONS */}
          {q.type === "mcq" && (q.options || []).map((opt, i) => {

            const selected = answers[qId];
            const isCorrect = i === correctIndex;

            return (
              <label
                key={i}
                className={`block border p-3 mb-3 rounded cursor-pointer
                  ${showResult && isCorrect ? "bg-green-100 border-green-500" : ""}
                  ${showResult && selected === i && !isCorrect ? "bg-red-100 border-red-500" : ""}
                `}
              >
                <input
                  type="radio"
                  checked={selected === i}
                  onChange={() => handleSelect(i)}
                  className="mr-2"
                />

                <span className="font-medium">{opt.text}</span>

                {/* OPTION MEDIA */}
                {opt.media?.url && (
                  opt.media.type === "video"
                    ? (
                      <video
                        src={`${process.env.REACT_APP_API_BASE_URL}${opt.media.url}`}
                        controls
                        className="mt-2 h-32 rounded"
                      />
                    )
                    : (
                      <img
                        src={`${process.env.REACT_APP_API_BASE_URL}${opt.media.url}`}
                        className="mt-2 max-w-xs rounded"
                        alt=""
                      />
                    )
                )}

              </label>
            );
          })}


{q.type === "truefalse" && (
  ["True", "False"].map((val, i) => {
    const selected = answers[qId];
    const isCorrect =
      val.toLowerCase() === q.answer?.toLowerCase();

    return (
      <label
        key={val}
        className={`block border p-3 mb-3 rounded cursor-pointer
          ${showResult && isCorrect ? "bg-green-100 border-green-500" : ""}
          ${showResult && selected === val && !isCorrect ? "bg-red-100 border-red-500" : ""}
        `}
      >
        <input
          type="radio"
          checked={selected === val}
          onChange={() => {
            setAnswers(prev => ({ ...prev, [qId]: val }));
            setShowResult(true);
          }}
          className="mr-2"
        />
        {val}
      </label>
    );
  })
)}



{q.type === "text" && (
  <div>
    <input
      type="text"
      value={answers[qId] || ""}
      onChange={(e) =>
        setAnswers(prev => ({ ...prev, [qId]: e.target.value }))
      }
      placeholder="Type your answer..."
      className="border p-2 rounded w-full"
    />

    <button
      onClick={() => setShowResult(true)}
      className="mt-3 bg-blue-600 text-white px-4 py-2 rounded"
    >
      Check Answer
    </button>
  </div>
)}
          {/* FEEDBACK */}
          {showResult && (
  <div className="mt-4">

    {/* MCQ */}
    {q.type === "mcq" && (
      answers[qId] === correctIndex
        ? <p className="text-green-600 font-bold">✔ Correct</p>
        : <p className="text-red-600 font-bold">
            ❌ Correct Answer: {q.options?.[correctIndex]?.text || "N/A"}
          </p>
    )}

    {/* TRUE/FALSE */}
    {q.type === "truefalse" && (
      answers[qId]?.toLowerCase() === q.answer?.toLowerCase()
        ? <p className="text-green-600 font-bold">✔ Correct</p>
        : <p className="text-red-600 font-bold">
            ❌ Correct Answer: {q.answer}
          </p>
    )}

    {/* TEXT */}
    {q.type === "text" && (
      answers[qId]?.toLowerCase().trim() ===
      q.answer?.toLowerCase().trim()
        ? <p className="text-green-600 font-bold">✔ Correct</p>
        : <p className="text-red-600 font-bold">
            ❌ Correct Answer: {q.answer}
          </p>
    )}

    {currentIndex < test.questions.length - 1
      ? (
        <button
          onClick={handleNext}
          className="mt-4 bg-blue-600 text-white px-4 py-2 rounded"
        >
          Next →
        </button>
      )
      : <p className="mt-4 text-green-600 font-bold">
          Practice Completed 🎯
        </p>
    }
  </div>
)}
        </div>

      </main>
    </div>
  );
}